import React, { useState, useEffect } from 'react';
import './ResetPassword.css';
import axios from "axios";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useToast } from '../../context/ToastContext';
import { getApiUrl } from '../../config';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { showToast } = useToast();
  
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isVerifying, setIsVerifying] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const [passwordError, setPasswordError] = useState('');

  useEffect(() => {
    // URL'den token'ı al
    const tokenFromUrl = searchParams.get('token');
    
    if (!tokenFromUrl) {
      showToast('Geçersiz şifre sıfırlama linki', 'error');
      navigate('/forgot-password');
      return;
    }

    setToken(tokenFromUrl);
    verifyToken(tokenFromUrl);
  }, [searchParams]);

  const verifyToken = async (tokenToVerify) => {
    setIsVerifying(true);
    
    try {
      const response = await axios.get(`${getApiUrl()}/verify-reset-token/${tokenToVerify}`);
      
      if (response.data.valid) {
        setTokenValid(true);
      } else {
        showToast('Geçersiz veya süresi dolmuş token', 'error');
        setTimeout(() => navigate('/forgot-password'), 2000);
      }
    } catch (error) {
      showToast('Token doğrulanamadı. Lütfen yeni bir şifre sıfırlama talebi oluşturun.', 'error');
      setTimeout(() => navigate('/forgot-password'), 2000);
    } finally {
      setIsVerifying(false);
    }
  };

  const validatePassword = () => {
    if (newPassword.length < 6) {
      setPasswordError('Şifre en az 6 karakter olmalıdır');
      return false;
    }
    
    if (newPassword !== confirmPassword) {
      setPasswordError('Şifreler eşleşmiyor');
      return false;
    }
    
    setPasswordError('');
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validatePassword()) {
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(`${getApiUrl()}/reset-password`, {
        token,
        new_password: newPassword
      });

      if (response.data.success) {
        showToast('Şifreniz başarıyla güncellendi! Giriş sayfasına yönlendiriliyorsunuz...', 'success');
        setTimeout(() => navigate('/login'), 2000);
      }
    } catch (error) {
      if (error.response) {
        const errorMsg = error.response.data.error || 'Şifre güncellenemedi';
        showToast(errorMsg, 'error');
        
        // Token geçersizse forgot-password sayfasına yönlendir
        if (errorMsg.includes('Geçersiz') || errorMsg.includes('dolmuş')) {
          setTimeout(() => navigate('/forgot-password'), 2000);
        }
      } else {
        showToast('Bir hata oluştu. Lütfen tekrar deneyin.', 'error');
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isVerifying) {
    return (
      <div className="resetPassword-container">
        <div className="verification-loading">
          <div className="spinner"></div>
          <p>Token doğrulanıyor...</p>
        </div>
      </div>
    );
  }

  if (!tokenValid) {
    return (
      <div className="resetPassword-container">
        <div className="error-message">
          <h2>Geçersiz Link</h2>
          <p>Bu şifre sıfırlama linki geçersiz veya süresi dolmuş.</p>
          <Link to="/forgot-password" className="back-link">Yeni Talep Oluştur</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="resetPassword-container">
      <h1 className="resetPassword-title">Yeni Şifre Belirle</h1>
      <p className="resetPassword-subtitle">Lütfen yeni şifrenizi girin</p>

      <form onSubmit={handleSubmit} className="resetPassword-form">
        <div className="form-group">
          <label className="resetPassword-label" htmlFor="newPassword">
            Yeni Şifre *
          </label>
          <input
            type="password"
            id="newPassword"
            name="newPassword"
            placeholder="En az 6 karakter"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className={`resetPassword-input ${passwordError ? 'input-error' : ''}`}
            required
            minLength={6}
          />
        </div>

        <div className="form-group">
          <label className="resetPassword-label" htmlFor="confirmPassword">
            Yeni Şifre (Tekrar) *
          </label>
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            placeholder="Şifrenizi tekrar girin"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className={`resetPassword-input ${passwordError ? 'input-error' : ''}`}
            required
            minLength={6}
          />
        </div>

        {passwordError && (
          <div className="error-alert">
            {passwordError}
          </div>
        )}

        <button 
          type="submit" 
          className="resetPassword-button" 
          disabled={isLoading}
        >
          {isLoading ? (
            <div className="spinner-container">
              <div className="spinner"></div>
              <span>Güncelleniyor...</span>
            </div>
          ) : (
            'Şifremi Güncelle'
          )}
        </button>
      </form>

      <p className="resetPassword-loginLink">
        Şifrenizi hatırladınız mı? <Link to="/login">Giriş Yap</Link>
      </p>
    </div>
  );
};

export default ResetPassword;
